<template>
  <div :style="{ width: '100%' }">
    <v-btn
      :class="`btn-download-mobile pa-0 ${
        disableDownloadIcon ? 'd-none' : 'd-md-none d-lg-none'
      }`"
      color="transparent"
      @click="download"
    >
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0002 7H16.0002L10.0002 13L4.00024 7H9.00025V0H11.0002V7ZM2.00024 16H18.0002V9H20.0002V17C20.0002 17.2652 19.8949 17.5196 19.7074 17.7071C19.5198 17.8946 19.2655 18 19.0002 18H1.00024C0.735028 18 0.480674 17.8946 0.293137 17.7071C0.105601 17.5196 0.000244141 17.2652 0.000244141 17V9H2.00024V16Z"
          fill="#A7B3C7"
        />
      </svg>
    </v-btn>
    <v-btn
      :class="`btn-download rounded-1 ${
        disableDownloadIcon ? '' : 'd-none'
      } d-md-block d-lg-block`"
      depressed
      outlined
      color="primary"
      height="24"
      @click="download"
    >
      <div class="btn-download__text">
        Download
      </div>
      <div class="btn-download__icon">
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.59253 11.2H11.7925V12H4.59253V11.2ZM8.59253 7.2H11.3925L8.19253 10.4L4.99253 7.2H7.79253V4H8.59253V7.2Z"
            fill="#029F48"
          />
        </svg>
      </div>
    </v-btn>
  </div>
</template>

<script>
import { handleDownloadFile } from '../../utils/misc';

export default {
  props: {
    file: {
      type: String,
      default: '',
    },
    disableDownloadIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    download() {
      handleDownloadFile(this.file);
      this.$emit('on-download')
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-download {
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  letter-spacing: 0.1px;
  text-transform: capitalize;
  width: 100%;
  @media screen and (min-width: 960px) {
    width: 100px;
  }
  &__text {
    margin-top: -2px;
  }
  &__icon {
    margin-top: 1px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
}
.btn-download-mobile {
  border: 0;
  box-shadow: none;
  position: absolute;
  top: 0;
  right: 0;
  min-width: initial !important;
}
</style>
